module.exports = __webpack_public_path__ + "img/chart_area.ae0427f3.svg";